module.exports = __webpack_public_path__ + "static/president-e55ed051d05cc8b612f7738039c5d980.webp";